import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiGet, apiPost } from 'api-service';

function adaptTreeData(tree) {
  return tree.map((node) => ({
    value: node.department_id,
    label: node.department_name,
    children: node.children ? adaptTreeData(node.children) : [],
  }));
}

export const fetchDepartments = createAsyncThunk(
  'departmentReducer/fetchDepartments',
  async (params = {}, thunkAPI) => {
    try {
      const response = await apiGet('/user/department', {
        tree: 1,
        ...params,
      });

      const adaptedTree = adaptTreeData(response.data?.result);

      return adaptedTree;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const addDepartment = createAsyncThunk(
  'departmentReducer/addDepartment',
  async (params = {}, thunkAPI) => {
    try {
      const response = await apiPost('/user/department', params);
      return response.data?.result;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
